import { Form } from "antd";
import dayjs from "dayjs";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";

const OfficerReportAdministrativeInfo = ({ report = {} }) => {
  return (
    <Form
      layout="vertical"
      initialValues={{
        officerReportID: report.officerReportID || "",
        dateTimeEntered:
          report.dateAdded && report.timeAdded
            ? dayjs(`${report.dateAdded} ${report.timeAdded}`, "MM/DD/YYYY HH:mm")
            : null,
        user: report.user || "",
      }}
    >
      <StyledGridRow gutter={16} justify={'start'}>
        <StyledGridCol span={4}>
          <FormItem label="ID" name="officerReportID">
            <TextField />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol span={6}>
          <FormItem label="Date & Time Added" name="dateTimeEntered">
            <CommonDatePicker format="MM/DD/YYYY HH:mm" />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol span={6}>
          <FormItem label="User" name="user">
            <TextField />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </Form>
  );
};

export default OfficerReportAdministrativeInfo;
